<template>
  <ServiceLayout
    icon="notext-starpick.png"
    title="Starpick"
    description="Layanan antar jemput oleh Guiders menggunakan transportasi publik ke bandara, stasiun, hitel atau tempat anda menginap."
    :extra_hour="null"
    :tariffs="starpick_tariffs"
    :lists="starpick_list"
  />
</template>

<script>
import ServiceLayout from '@/components/ServiceLayout'

export default {
  name: 'StarPick',
  components: {
    'ServiceLayout': ServiceLayout
  },
  data () {
    return {
      starpick_list: [
        {
          icon: 'tepat-waktu.png',
          icon_position: 'right',
          title: 'Tepat Waktu',
          subtitle: 'Cocok untuk anda jika ingin di jemput atau di antar Oleh Guiders ke Bandara, Stasiun, dan lainnya.'
        },
        {
          icon: 'tarif-pasti.png',
          icon_position: 'left',
          title: 'Tarif Pasti',
          subtitle: 'Kami memberikan tarif pasti kepada setiap Member STARGUIDES dan tidak perlu khawatir tawar menawar lagi karna biaya nya sudah pasti.'
        },
        {
          icon: 'friendly.png',
          icon_position: 'right',
          title: 'Friendly',
          subtitle: 'Guiders kami akan selalu memberikan pelayanan dan sikap yang terbaik bagi semua member STARGUIDES.'
        },
        {
          icon: 'aman-nyaman.png',
          icon_position: 'left',
          title: 'Aman dan Nyaman',
          subtitle: 'Guiders kami akan selalu berusaha untuk memberikan keamanan dan kenyamanan selama bepergian di kota-kota yang anda kunjungi dengan STARPICK.'
        },
        {
          icon: 'kemudahan-pembayaran.png',
          icon_position: 'right',
          title: 'Kemudahan Pembayaran',
          subtitle: 'Tidak perlu khawatir soal uang kembalian atau uang tunai, dengan, kartu kredit, layanan kami kini semakin praktis.'
        }
      ],
      starpick_tariffs: [
        'Rp. 778.400*'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Service/StarPick.vue